<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showRequestFeedback"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Request Feedback</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <div class="p-3">
            <div  v-for="level in levels"
                  :key="level.key"
                  class="mb-4 ">
              <label class="block pb-1 font-bold">{{level.name}}</label>
              <select
                  class="p-2 bg-gray-200 rounded-full w-full"
                  v-model="selectedEmployee"
              >
                <option value="" disabled>Select an Employee</option>
                <option
                    v-for="employee in employees[level.key]"
                    :key="employee.EmployeeId"
                    :value="employee.EmployeeId"
                >
                  {{  decryptDataLocal(employee.EmployeeName , decryptionKey)}} {{level.key}}
                </option>
              </select>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Request Feedback
            </button>
          </div>
        </div>
      </div>
      >
    </transition>
  </div>
</template>

<script>
import { ref } from 'vue';
import decryptData from "@/utils/decrypt";
import axios from "axios";
import {mapGetters} from "vuex";
export default {
  name: "RequestFeedback",
  props: ["showRequestFeedback", "getUserRole"],
  computed:{
    ...mapGetters(["getOrganization", "getToken"]),

  },
  created() {
    this.fetchEmployees()
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
  },
  setup() {
    const employees = ref([
      { id: 1, name: 'Employee 1' },
      { id: 2, name: 'Employee 2' },
      { id: 3, name: 'Employee 3' },
    ]);

    const selectedEmployees = ref([]);
    const getEmployeeName = (id) => {
      const employee = employees.value.find((emp) => emp.id === id);
      return employee ? employee.name : '';
    };
    const handleCheckboxChange = (id) => {
      if (selectedEmployees.value.includes(id)) {
        // Remove if already selected
        selectedEmployees.value = selectedEmployees.value.filter(
            (empId) => empId !== id
        );
      } else {
        // Add if not selected
        selectedEmployees.value.push(id);
      }
    };
    return {
      employees,
      selectedEmployees,
      getEmployeeName,
      handleCheckboxChange,
    };


  },
  data() {
    return {
      selectedType: "single",
      activeItem: '',
      selectedEmployee: "",
      levels:[
        {
          name:"Higher Level",
          key:"HighLevelEmployees"
        },
        {
          name: "Same Level",
          key:"SameLevelEmployees"
        },
        {
          name:"Lower Level",
          key:"LowLevelEmployees"
        }
      ],
      employees: [],
      decryptionKey: '',
      decryptDataLocal: '',
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    fetchEmployees(){
      this.loading = true;
      let url = `${this.getOrganization}/performance/360evaluation/employee/hierarchy/${this.$ApiVersion}/request`;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            console.log(response.data)
            if (response.data.StatusCode == 200) {
              this.employees=response.data.Data
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
      );
    }

  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.selected-list ul {
  list-style-type: disc;
  padding-left: 1.5rem;
}
</style>
